import { DocketTemplateFormProvider } from "./DocketTemplateFormProvider";
import { AutomaticallyPrintInput } from "./components";
import { NameInputField } from "./components/NameInputField";

export interface DocketTemplateFormProps {}

export const DocketTemplateForm = ({}: DocketTemplateFormProps) => {
  return null;
};

DocketTemplateForm.Provider = DocketTemplateFormProvider;
DocketTemplateForm.NameInputField = NameInputField;
DocketTemplateForm.AutomaticallyPrintInput = AutomaticallyPrintInput;
